// extracted by mini-css-extract-plugin
export default {"container":"EK-z","dimension":"FK-z","dimensionLabels":"GK-z"};